import { render, staticRenderFns } from "./RawTable.vue?vue&type=template&id=48be7634&scoped=true"
import script from "./RawTable.vue?vue&type=script&lang=js"
export * from "./RawTable.vue?vue&type=script&lang=js"
import style0 from "./RawTable.vue?vue&type=style&index=0&id=48be7634&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48be7634",
  null
  
)

export default component.exports